export function scrollToElement(idElement: string): void {
  const elem = document.getElementById(idElement);
  if (elem) {
    window.scrollTo({
      top: elem.offsetTop,
      behavior: 'smooth',
    });
  }
}
